<template>
  <div>
    <SearchableTable
      :panel-header="'Medikamente'"
      :panel-route="'AddMedication'"
      :show-search-bar="true"
      :table-data="medicationData"
      :table-meta-data="tableMetaData"
      :query-string="'setMedicationSearchQuery'"
      :initial-search-query="medicationSearchQuery"
      :row-click="triggerView"
      :event-value="parentEventValue"
    >
      <b-table-column
        v-slot="props"
        label=""
        cell-class="has-text-right truncate-column"
        header-class="th-right truncate-column"
      >
        <b-button
          class="is-small"
          @click.stop="triggerDelete(props.row)"
        >
          <b-icon
            class="mt-1"
            icon="delete"
            style="cursor: pointer"
          />
        </b-button>
      </b-table-column>
    </SearchableTable>
    <ModalComponent
      v-if="isDeleteCheck"
      :item="chosenElement.attributes.name"
      :is-delete-check="isDeleteCheck"
      :is-loading="isLoading"
      :cancel="() => isDeleteCheck = false"
      :submit="submitDelete"
    />
  </div>
</template>

<script>
/**
 * This file shows all currently stored medications and allows adding,
 * viewing and soft deleting them; editing happens on the view page.
 */
import { negativeFeedBack, positiveFeedBack } from "@/lib/Toast";
import { mapGetters } from "vuex";
import SearchableTable from "@/components/helperComponents/SearchableTable.vue";
import ModalComponent from "@/components/helperComponents/ModalComponent";

export default {
	name: "MedicationTable",
	components: { ModalComponent, SearchableTable },
	data() {
		return {
			parentEventValue: undefined,
			isDeleteCheck: false,
			chosenElement: {},
			isLoading: false,
			tableMetaData: [
				{ "id": 0, "type": "string", "label": "Bezeichner", "field": "name", "sortField": "attributes.name" },
				{ "id": 1, "type": "string", "label": "Stärke", "field": "potency", "sortField": "attributes.potency" },
				{ "id": 2, "type": "combination", "label": "Anzahl/(Füll-)Menge", "symbol": " ", "alternativeSymbol": " ", "field": [["max"], ["medicationUnit", "symbol"]], "sortField": "attributes.max" },
				{ "id": 3, "type": "ref", "label": "Art", "field": "name", "sortField": "attributes.medicationForm.attributes.name", "refName": "medicationForm" },
			]
		};
	},
	computed: {
		...mapGetters({
			medicationData: "getMedication",
			medicationSearchQuery: "getMedicationSearchQuery"
		})
	},
	methods: {
		triggerView(element) {
			this.$router.push(
				{ name: "ViewMedication", params: { id: element.id, data: element } });
		},
		triggerDelete(element) {
			this.chosenElement = element;
			this.isDeleteCheck = true;
		},
		async submitDelete() {
			this.isLoading = true;
			const name = this.chosenElement.attributes.name;
			this.chosenElement.set("deleted", true);
			try {
				await this.chosenElement.save();
				this.$store.dispatch("medication/delete", this.chosenElement);
			}
			catch (e) {
				negativeFeedBack(name + " nicht gelöscht!");
				console.error(e);
				return;
			}
			finally {
				this.isLoading = false;
				this.isDeleteCheck = false;
			}
			await positiveFeedBack(name + " gelöscht!");
		}
	},
};

</script>

<style scoped></style>
